var config = require('../config/settings.json');

import Vue from 'vue';
import Tools from "../store/tools.js";

export default {
    isAuthorized(context,slugQuiz,groupId,firstname,lastname,birthday,callback){
      var data = {
        firstname:firstname,
        lastname:lastname,
        birthday:birthday
      }
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "responses/"+slugQuiz+"/"+groupId+"/isAuthorized/",data).then((response) => {
          callback(null); // response.data = null;
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(Tools.translate(response.data));
      });
      // /:quizSlug/isAuthorized
    }
}



// WEBPACK FOOTER //
// ./src/requests/responses.js